import styled from "styled-components";

interface BodyCellProps {
  isEven: boolean;
}

export const BodyRow = styled.tr`
  height: 56px;

  &:hover > td {
    background-color: #deecff;
  }
`;

export const BodyCell = styled.td<BodyCellProps>`
  box-sizing: border-box;
  background-color: ${(p) => (p.isEven ? "#FFFFFF" : "#F2F2F2")};
  border-right: 1px solid #666666;
  height: 56px;
  max-height: 56px;
  padding: 0 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;

  &:first-child {
    border-right: none;
  }
`;
